// extracted by mini-css-extract-plugin
export default {"PageWrapper":"PageWrapper_PageWrapper__vSkmH","PageWrapper__content":"PageWrapper_PageWrapper__content__YVLr1","hidden":"PageWrapper_hidden__FAYUj"};